module.exports = __webpack_public_path__ + "img/1557614101089296386.6bfbbc12.png";